export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives.64964c40.jpg";